import { cn } from "@/lib/cn"
import type { ChartToolMode } from "@/types/chartOverlays"

const TOOL_LABELS: Record<ChartToolMode, string> = {
  pan: "Pan",
  horizontal_line: "H-Line",
  horizontal_ray: "H-Ray",
}

interface Props {
  toolMode: ChartToolMode
  onToolModeChange: (mode: ChartToolMode) => void
  showSuggestions: boolean
  onToggleSuggestions: () => void
  signedIn: boolean
  onDeleteSelected?: () => void
}

export function ChartDrawingToolbar({
  toolMode,
  onToolModeChange,
  showSuggestions,
  onToggleSuggestions,
  signedIn,
  onDeleteSelected,
}: Props) {
  if (!signedIn) return null

  return (
    <div className="flex flex-wrap items-center gap-2">
      {(Object.keys(TOOL_LABELS) as ChartToolMode[]).map((mode) => (
        <button
          key={mode}
          type="button"
          onClick={() => onToolModeChange(mode)}
          className={cn(
            "rounded-lg border px-2.5 py-1 text-[11px] transition",
            toolMode === mode
              ? "border-cyan-400/40 bg-cyan-400/10 text-cyan-300"
              : "border-slate-700 text-slate-500 hover:text-slate-300",
          )}
        >
          {TOOL_LABELS[mode]}
        </button>
      ))}
      <button
        type="button"
        onClick={onToggleSuggestions}
        className={cn(
          "rounded-lg border px-2.5 py-1 text-[11px] transition",
          showSuggestions
            ? "border-amber-400/40 bg-amber-400/10 text-amber-300"
            : "border-slate-700 text-slate-500 hover:text-slate-300",
        )}
      >
        Suggestions
      </button>
      {onDeleteSelected && (
        <button
          type="button"
          onClick={onDeleteSelected}
          className="rounded-lg border border-rose-400/40 px-2.5 py-1 text-[11px] text-rose-300 transition hover:bg-rose-400/10"
        >
          Delete level
        </button>
      )}
    </div>
  )
}
